/**
 * Webview Event Types
 *
 * Defines all event types and their payload structures for communication
 * between the web app and native webview container.
 */

/**
 * Event types that can be sent TO native (web -> native)
 */
export enum WebviewSendEventType {
  /** Toggle the native pull-to-refresh gesture based on scroll position */
  SET_PULL_TO_REFRESH_ENABLED = 'SET_PULL_TO_REFRESH_ENABLED',
}

/**
 * Payload for SET_PULL_TO_REFRESH_ENABLED event
 */
export interface SetPullToRefreshEnabledPayload {
  /** Whether the pull-to-refresh gesture should be enabled on the native side */
  enabled: boolean;
}
